import { Pipe, PipeTransform } from '@angular/core';

import { Groupe } from '../../offre-regionale/models/groupe.model';

@Pipe({
  name: 'filtrerParAnnee',
})
export class FiltrerParAnneePipe implements PipeTransform {
  transform(groupes: Groupe[], annee: 1 | 2 | 3): Groupe[] {
    return groupes.filter((x) => x.annee === annee);
  }
}
